import {Fragment} from 'react';
import Logo from '../../assets/autozilla_logo_small.png';
import Logo_small from '../../assets/m1.png';
import classes from './Header.module.css';
import pageStyles from './PageLoader.css';

const Header = props =>{
    return <Fragment>
            <header className={classes.header}>
                <div className='container'>
                <span>                    
					<img src= {Logo} alt='Auto Parts By Autozilla' className='desk_logo'/>       
                                      
                </span>  
                </div>             
            </header>
			<div id="loader-wrapper" className="loader-wrapper-new">
				<div id="loader"></div>
				<div className="loader-section section-left"></div>
				<div className="loader-section section-right"></div>
			</div>
			
        </Fragment>
}

export default Header;